import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HelmetProvider } from "react-helmet-async";
import { PrimeReactProvider } from 'primereact/api';
// ✅ Google Analytics (GA4)
const GA_MEASUREMENT_ID = "G-87BBX0LFV5";

// Load GA script
(function () {
  const script = document.createElement("script");
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  script.async = true;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag(){ window.dataLayer.push(arguments); }
  window.gtag = gtag;

  gtag("js", new Date());
  gtag("config", GA_MEASUREMENT_ID);
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
     <React.StrictMode>
    <PrimeReactProvider>
      <App />
    </PrimeReactProvider>
  </React.StrictMode> 

  </HelmetProvider>
);

// Optional: Send web vitals to GA
reportWebVitals((metric) => {
  window.gtag && window.gtag("event", metric.name, {
    value: metric.value,
    event_category: "Web Vitals",
  });
});
